import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalStorageConstants } from '@shared/constants/local-storage-constants';

/** The request carrying the token stored right now. */
export function withStoredToken<T>(request: HttpRequest<T>): HttpRequest<T> {
  return request.clone({
    setHeaders: {
      [LocalStorageConstants.TokenHeader]: `${
        localStorage.getItem(LocalStorageConstants.Token) || ''
      }`,
    },
  });
}

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor() {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(withStoredToken(request));
  }
}
